import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from "rxjs";
import { ServiceDealer } from "./api-interfaces/serviceDealer.interface";
import { HelperService } from "../helperService";

@Injectable({
    providedIn: 'root'
})
export class APIServiceDealer {
    ApiURL: string = "";
    constructor(private http: HttpClient,public helperService: HelperService) {
        this.ApiURL = environment.ServicerDealerUrl + 'ServiceDealer/';
    }

    public get(serviceId: string): Observable<any>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
          };
        if (serviceId!== null && serviceId!== undefined) {
            return this.http.get(this.ApiURL + encodeURIComponent(serviceId),requestOptions);
       } else {
           return this.http.get(this.ApiURL,requestOptions );
        }
    }
    public getByworkshopId(workshopId: string): Observable<any> {
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
          };
        let apiURL = `${this.ApiURL}bydealer/${workshopId}`;
        return this.http.get(apiURL,requestOptions);
    }

    public post(dataInt:ServiceDealer): Observable<any>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
          };
        return this.http.post<any>(this.ApiURL,dataInt,requestOptions )

    }

    public put(data): Observable<any>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
          };
        return this.http.put<any>(this.ApiURL, data,requestOptions)
    }
    
    public delete(id: number):  Observable<any>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
          };
        let apiURL = `${this.ApiURL}${id}`;
        return this.http.delete(apiURL,requestOptions)
    }

}